import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class IdResponseOfString
*  Ответ на запрос создания сущности, содержащий в себе идентификатор созданной сущности
*/
export class IdResponseOfString extends ActiveModel {

/**
  * id
  * Идентификатор созданной сущности
  */
  @ActiveField()
  id?: null | string
}
